import { API_CORE } from "../../_CORE/API/ApiCORE";
import { REACT_HOT_TOAST_ERROR, REACT_HOT_TOAST_SUCCESS } from "../../_CORE/HELPERS/reactHotToast.helper";

/*
    🔥 ACCIONES CON RUTA PARAMETRIZADA Y AVISO EN PANTALLA

    ⚠️ POR QUÉ NO ALCANZA CON actionMutate

    actionMutate arma la url pegando el id al final del endpoint. Sirve
    para /companies/:id, pero no para /companies/:id/archive: ahí queda
    /companies/:id/archive/<id> y el servidor responde 404 sin que se vea
    nada en pantalla.

    Acá reemplazamos los parametros dentro de la ruta y, pase lo que pase,
    el resultado se avisa: si falla, el mensaje del servidor sale en un
    toast en vez de quedar escondido en la consola.
*/

/*
    ⚠️ DELETE_resource siempre pega `/${id}` al final, asi que la url ya
    resuelta se corta en dos: base + ultimo segmento.
*/
const onSplitUrl = (url) => {
    const PARTES = url.split('/');
    const ULTIMO = PARTES.pop();
    return [PARTES.join('/'), ULTIMO];
};

const METODOS = {
    GET: (url) => API_CORE.SERVICES.GET_RESOURCE(url),
    POST: (url, data) => API_CORE.SERVICES.POST_RESOURCE(url, data ?? {}),
    PATCH: (url, data) => API_CORE.SERVICES.PATCH_resource(url, data ?? {}),
    DELETE: (url) => API_CORE.SERVICES.DELETE_resource(...onSplitUrl(url)),
};

export const onApiAction = async ({
    method = "POST", endpoint, pathParams = {}, data = null,
    successMessage = null, isToastError = true,
}) => {

    const HANDLER = METODOS[method.toUpperCase()];

    if (!HANDLER) {
        REACT_HOT_TOAST_ERROR(`Método no soportado: ${method}`);
        return { success: false, data: null, message: `Método no soportado: ${method}` };
    }

    let url = API_CORE.ENDPOINTS[endpoint];

    if (!url) {
        REACT_HOT_TOAST_ERROR(`No encontramos el endpoint ${endpoint}`);
        return { success: false, data: null, message: `Endpoint desconocido: ${endpoint}` };
    }

    Object.entries(pathParams).forEach(([key, value]) => {
        url = url.replace(`:${key}`, value);
    });

    try {

        const RESPONSE = await HANDLER(url, data);

        const IS_OK = RESPONSE?.success ?? (RESPONSE?.status >= 200 && RESPONSE?.status < 300);

        if (!IS_OK) {

            const MENSAJE = RESPONSE?.message ?? RESPONSE?.data?.message ?? "No se pudo completar la acción";
            const DETAIL = RESPONSE?.detail ?? RESPONSE?.data?.detail ?? null;
            const FIELDS = RESPONSE?.errors ?? RESPONSE?.fields ?? RESPONSE?.data?.errors ?? null;
            const REQUEST_ID = RESPONSE?.requestId ?? RESPONSE?.data?.requestId ?? null;
            const CODE = RESPONSE?.code ?? RESPONSE?.data?.code ?? null;
            const STATUS = Number(RESPONSE?.status ?? RESPONSE?.code_status ?? RESPONSE?.data?.status ?? 400);
            const PRIMER_ERROR = FIELDS && typeof FIELDS === "object"
                ? Object.values(FIELDS).find(Boolean)
                : null;

            if (isToastError) {
                const TEXTO = [
                    MENSAJE,
                    PRIMER_ERROR && PRIMER_ERROR !== MENSAJE ? PRIMER_ERROR : null,
                    !PRIMER_ERROR && DETAIL && DETAIL !== MENSAJE ? DETAIL : null,
                    REQUEST_ID ? `Referencia: ${REQUEST_ID}` : null,
                ].filter(Boolean).join("\n");
                REACT_HOT_TOAST_ERROR(TEXTO);
            }

            return {
                success: false,
                status: STATUS,
                code_status: STATUS,
                code: CODE,
                data: RESPONSE?.data?.data ?? null,
                message: MENSAJE,
                detail: DETAIL,
                fields: FIELDS,
                errors: FIELDS,
                requestId: REQUEST_ID,
            };
        }

        if (successMessage) REACT_HOT_TOAST_SUCCESS(successMessage);

        return { success: true, data: RESPONSE?.data ?? null, message: RESPONSE?.message ?? "" };

    } catch (error) {

        const BODY = error?.response?.data ?? {};
        const MENSAJE = BODY?.message ?? error?.message ?? "Error inesperado";
        const DETAIL = BODY?.detail ?? null;
        const FIELDS = BODY?.errors && typeof BODY.errors === "object" && !Array.isArray(BODY.errors)
            ? BODY.errors
            : null;
        const REQUEST_ID = BODY?.requestId ?? null;
        const STATUS = Number(error?.response?.status ?? BODY?.status ?? 500);
        const PRIMER_ERROR = FIELDS ? Object.values(FIELDS).find(Boolean) : null;

        if (isToastError) {
            REACT_HOT_TOAST_ERROR([
                MENSAJE,
                PRIMER_ERROR && PRIMER_ERROR !== MENSAJE ? PRIMER_ERROR : null,
                !PRIMER_ERROR && DETAIL && DETAIL !== MENSAJE ? DETAIL : null,
                REQUEST_ID ? `Referencia: ${REQUEST_ID}` : null,
            ].filter(Boolean).join("\n"));
        }

        return {
            success: false,
            status: STATUS,
            code_status: STATUS,
            code: BODY?.code ?? `HTTP_${STATUS}`,
            data: BODY?.data ?? null,
            message: MENSAJE,
            detail: DETAIL,
            fields: FIELDS,
            errors: FIELDS,
            requestId: REQUEST_ID,
        };
    }
};
